/**
 * pending-messages — /chat → /chat/:sessionId 라우트 전환 시
 * "보낼 메시지"를 임시 저장하는 모듈 레벨 저장소.
 *
 * 플로우:
 * 1. /chat 에서 사용자가 starter/입력 submit
 * 2. 서버에 세션 생성 요청 → sessionId 수신
 * 3. setPendingMessage(sessionId, text) 로 저장
 * 4. navigate({to: "/chat/$sessionId", params: {sessionId}})
 * 5. 새 ChatZone 이 mount되면서 consumePendingMessage(sessionId) 로 꺼내 send() 1회
 *
 * URL search param 이나 location state 는 새로고침/뒤로가기 시 재실행되거나
 * 노출되는 문제가 있어, 의도적으로 메모리 전용 Map 을 사용한다.
 * (탭 간 공유 불필요, 새로고침 시 consume 실패 = 정상 동작)
 */

const pendingMessages = new Map<string, string>();

export function setPendingMessage(sessionId: string, message: string): void {
  pendingMessages.set(sessionId, message);
}

export function consumePendingMessage(sessionId: string): string | undefined {
  const value = pendingMessages.get(sessionId);
  if (value !== undefined) {
    pendingMessages.delete(sessionId);
  }
  return value;
}
